export const serializeTicketReason = (
  { id, title, is_active, skill_group_ids },
  currentManagerSkillGroupIds
) => {
  const active =
    is_active &&
    skill_group_ids.some(r => currentManagerSkillGroupIds.includes(r));

  return {
    id: String(id),
    title,
    active,
  };
};

export const serializeTicketReasons = (
  reasons,
  currentManagerSkillGroupIds
) => {
  if (!reasons || reasons.length <= 0) return null;

  return reasons.map(reason =>
    serializeTicketReason(reason, currentManagerSkillGroupIds)
  );
};
